module.exports = __webpack_public_path__ + "img/wallet.16417663.svg";